import { createFeatureSelector } from '@ngrx/store';
import { SearchRecipesState } from '../models/search.model';
import { PointsMultiplierCreateUpdateState } from '../models/points-multiplier.model';
import { SearchRecipesReducer } from './search.reducer';
import { PointsMultiplierCreateUpdateReducer } from './points-multiplier.reducer';
import { SharedState } from '../models/shared.model';
import { SharedReducer } from './shared.reducer';
import { RegistrationPointsCreateUpdateState } from '../models/registration-points.model';
import { RegistrationPointsCreateUpdateReducer } from './registration-points.reducer';

export const featureRecipesName = 'Recipes';

export interface DragonflyRewardRulesState {
  search: SearchRecipesState;
  shared: SharedState;
  pointsMultiplierCreateUpdate: PointsMultiplierCreateUpdateState;
  registrationPointsCreateUpdate: RegistrationPointsCreateUpdateState;
}

export const moduleRecipeReducers = {
  search: SearchRecipesReducer,
  shared: SharedReducer,
  pointsMultiplierCreateUpdate: PointsMultiplierCreateUpdateReducer,
  registrationPointsCreateUpdate: RegistrationPointsCreateUpdateReducer,
};

export const getDragonflyRecipesState = createFeatureSelector<DragonflyRewardRulesState>(featureRecipesName);
